import React from 'react';
import { BouncingBoxWithText } from '../../widgets/bouncing-box-loader';
import { TaxReportingViewDiv } from '../styles';

interface Props {
  // Refer to DATA_STATUS for possible strings
  isLoadingOrErrored: string | undefined;
}

// TODO: Add alert for when the API call to /property/tot has errored
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function LoadingView(props: Props): React.ReactElement {
  return (
    <TaxReportingViewDiv data-testid="loading-box-tax-tab">
      <BouncingBoxWithText loadingText="Loading" />
    </TaxReportingViewDiv>
  );
}
